import LeftNode from './LeftNode'

export default class Alternator extends LeftNode {
  constructor() {
    super()
  }

  getChildCandidates () {
    return [] 
  }

  calculateInputData () {
    return null
  }
}
